import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import '../mvp/my-package.scss';
import * as sessionActions from 'redux/actions/mvp/session.action';
import moment from "moment/moment";
import upgradePackage from 'static/images/mvp/upgrade-package.png'
import existSession from 'static/images/mvp/exist-sessions.png'
import sessionInPackage from 'static/images/mvp/session-in-package.png'
import expiredDateImage from 'static/images/mvp/expired-date.png'
import startDateImage from 'static/images/mvp/start-date.png'
import { Link } from 'react-router-dom';
import { I18n } from '../../../../helpers/i18n';

class MyPackageContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      historyUseSessions: [],
      historyTransactions: [],
    };
  }

  async componentDidMount() {
    const { getHistoryUseSessions, getHistoryTransactions } = this.props;
    getHistoryUseSessions().then(rs => {
      this.setState({ historyUseSessions: rs });
    })
    getHistoryTransactions().then(rs => {
      this.setState({ historyTransactions: rs });
    })
  }

  render() {
    const { user } = this.props
    const { historyUseSessions, historyTransactions } = this.state

    console.log('user', user)
    console.log('historyUseSessions', historyUseSessions)
    console.log('historyTransactions', historyTransactions)
    // Kiểm tra user có package hay không
    const hasPackage = user?.wallet?.package || user?.wallet?.packageId;
    console.log('hasPackage', hasPackage)
    let expiredDate = ""
    if (user?.wallet) {
      expiredDate = moment(user?.wallet?.expiredDate).format('D/M/Y')
    }
    let startDate = ""
    if (user?.wallet) {
      startDate = moment(user?.wallet?.startDate).format('D/M/Y')
    }
    
    return (
      <div className="my-package-content" style={{ padding: '20px' }}>
        {/* Hiển thị phần upgrade package nếu user chưa có package */}
        {!hasPackage && (
          <div className="row">
            <div className="title-package col-lg-12 col-md-12 col-sm-12 mb-12">
              <div className="row package-row">
                <div className="my-package-name col-md-9">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.3133 25.7656H10.6953V44.8685C10.6952 45.3124 10.829 45.7445 11.0768 46.1007C11.3247 46.4568 11.6733 46.7181 12.0711 46.8457L29.4492 52.4181C29.8114 52.5337 30.1973 52.5337 30.5595 52.4181L47.9376 46.8457C48.3353 46.7181 48.684 46.4568 48.9318 46.1007C49.1796 45.7445 49.3134 45.3124 49.3133 44.8685V25.7656Z" fill="url(#paint0_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.3063 25.7656H29.9973C29.9973 25.7656 29.81 52.5048 29.9973 52.5048C30.1846 52.5048 30.3709 52.4759 30.5524 52.4181L47.9305 46.8457C48.3283 46.7181 48.6769 46.4568 48.9248 46.1007C49.1726 45.7445 49.3064 45.3124 49.3063 44.8685V25.7656Z" fill="url(#paint1_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.9991 32.4618L10.6901 25.7656L5.79046 33.5298C5.70671 33.6623 5.65291 33.8138 5.63332 33.9723C5.61372 34.1309 5.62886 34.2921 5.67755 34.4433C5.72623 34.5945 5.80712 34.7315 5.91384 34.8436C6.02057 34.9557 6.15019 35.0397 6.29249 35.089L23.6658 41.1216C23.8648 41.1908 24.0795 41.189 24.2775 41.1164C24.4755 41.0438 24.6461 40.9044 24.7635 40.7192L29.9991 32.4618Z" fill="url(#paint2_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.309 25.7656L30 32.4618L35.2356 40.7192C35.3531 40.9044 35.5236 41.0438 35.7216 41.1164C35.9196 41.189 36.1343 41.1908 36.3334 41.1216L53.7066 35.089C53.8489 35.0397 53.9786 34.9557 54.0853 34.8436C54.192 34.7315 54.2729 34.5945 54.3216 34.4433C54.3703 34.2921 54.3854 34.1309 54.3658 33.9723C54.3462 33.8138 54.2924 33.6623 54.2087 33.5298L49.309 25.7656Z" fill="url(#paint3_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3187 11.701C25.2011 11.5164 25.0306 11.3776 24.8328 11.3054C24.6351 11.2332 24.4207 11.2315 24.222 11.3007L6.84776 17.3343C6.70535 17.3833 6.57558 17.4671 6.46874 17.5791C6.3619 17.691 6.28091 17.828 6.23219 17.9792C6.18348 18.1304 6.16838 18.2917 6.18808 18.4502C6.20779 18.6087 6.26176 18.7601 6.34572 18.8925L10.6835 25.7672L29.9925 19.0483L25.3187 11.701Z" fill="url(#paint4_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M53.6468 18.8925C53.7303 18.76 53.784 18.6086 53.8035 18.4502C53.8229 18.2918 53.8078 18.1307 53.7591 17.9797C53.7104 17.8286 53.6296 17.6917 53.523 17.5797C53.4164 17.4677 53.2869 17.3837 53.1447 17.3343L35.7705 11.3007C35.5718 11.2315 35.3574 11.2332 35.1597 11.3054C34.9619 11.3776 34.7914 11.5164 34.6737 11.701L30 19.0483L49.309 25.7672L53.6468 18.8925Z" fill="url(#paint5_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.3133 25.7657L30.0043 19.0469L10.6953 25.7657L30.0043 32.4618L49.3133 25.7657Z" fill="url(#paint6_linear_10432_22517)"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30.0043 32.4618V19.0469L10.6953 25.7657L30.0043 32.4618Z" fill="url(#paint7_linear_10432_22517)"/>
                    <defs>
                    <linearGradient id="paint0_linear_10432_22517" x1="10.6953" y1="39.1352" x2="49.3133" y2="39.1352" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#CADCF0"/>
                    <stop offset="1" stop-color="#A4BBDB"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_10432_22517" x1="29.9143" y1="39.1352" x2="49.3063" y2="39.1352" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#A4BBDB"/>
                    <stop offset="1" stop-color="#8DA3BE"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear_10432_22517" x1="10.8185" y1="25.7574" x2="13.8918" y2="44.7805" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E9F3FC"/>
                    <stop offset="1" stop-color="#CADCF0"/>
                    </linearGradient>
                    <linearGradient id="paint3_linear_10432_22517" x1="30.0782" y1="32.3916" x2="51.0845" y2="43.6947" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E9F3FC"/>
                    <stop offset="1" stop-color="#CADCF0"/>
                    </linearGradient>
                    <linearGradient id="paint4_linear_10432_22517" x1="8.15594" y1="21.7623" x2="11.4634" y2="7.17547" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E9F3FC"/>
                    <stop offset="1" stop-color="#CADCF0"/>
                    </linearGradient>
                    <linearGradient id="paint5_linear_10432_22517" x1="35.169" y1="11.052" x2="36.3583" y2="29.1574" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#E9F3FC"/>
                    <stop offset="1" stop-color="#CADCF0"/>
                    </linearGradient>
                    <linearGradient id="paint6_linear_10432_22517" x1="10.6953" y1="25.7544" x2="49.3133" y2="25.7544" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#CADCF0"/>
                    <stop offset="1" stop-color="#A4BBDB"/>
                    </linearGradient>
                    <linearGradient id="paint7_linear_10432_22517" x1="31.9902" y1="18.7498" x2="32.4655" y2="35.417" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#A4BBDB"/>
                    <stop offset="1" stop-color="#8DA3BE"/>
                    </linearGradient>
                    </defs>
                </svg>
                <span>{I18n.t('upgrade_package_title')}</span>
              </div>
              <div className="upgrade-package-button col-md-3">
                <Link to="/packages">
                    <span>{I18n.t('upgrade_package_now')}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        )}
        
        {/* Hiển thị thông tin gói nếu user đã có package */}
        {hasPackage && (
          <div className="row">
            <div className="title-package col-lg-12 col-md-12 col-sm-12 mb-12">
              <div className="row package-row">
                <div className="my-package-name col-md-10">
                  <span className="package-name">{user?.wallet?.package}</span>
                </div>
              <div className="upgrade-package col-md-2">
                <Link to="/packages"><img src={upgradePackage} alt="upgradePackage" /></Link>
                <p className="package-row-text">{I18n.t('upgrade_package')}</p>
              </div>
            </div>
          </div>

          <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12 package-row">
            <p className="title"> {I18n.t('package_information')} </p>
            <div className="info">
              <div className="row">
                <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                  <img src={existSession} alt="existSession" />
                  <div className="detail">
                    <span className="number-or-date">{user?.wallet?.existSession || 0}</span>
                    <span className="description">{I18n.t('remaining_sessions')}</span>
                  </div>
                </div>
                <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                  <img src={sessionInPackage} alt="sessionInPackage" />
                  <div className="detail">
                    <span className="number-or-date">{user?.wallet?.sessionInPackage || 0}</span>
                    <span className="description">{I18n.t('number_sessions_in_package')}</span>
                  </div>
                </div>
                <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                  <img src={expiredDateImage} alt="expiredDate" />
                  <div className="detail">
                    <span className="number-or-date">{expiredDate || '-'}</span>
                    <span className="description">{I18n.t('expiry_date')}</span>
                  </div>
                </div>
                <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                  <img src={startDateImage} alt="startDate" />
                  <div className="detail">
                    <span className="number-or-date">{startDate || '-'}</span>
                    <span className="description">{I18n.t('start_date')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12 package-row">
            <p className="title"> {I18n.t('transaction_history')} </p>
            <div className="info">
              <div className="row history">
                <div className="col-lg-3 col-md-3 col-sm-3 mb-2">
                  <span>{I18n.t('registration_period')}</span>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-7 mb-8">
                  <span>{I18n.t('connection_sessions')}</span>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2 mb-2">
                  <span>{I18n.t('dashboard_filter_status')}</span>
                </div>
              </div>

              {
                historyUseSessions && historyUseSessions.length > 0 ? (
                  historyUseSessions.map((item, index) => (
                    <div key={index} className="row history-detail">
                      <div className="col-lg-3 col-md-3 col-sm-3 mb-2">
                        <span>{item.time}</span>
                      </div>
                      <div className="col-lg-7 col-md-7 col-sm-7 mb-8">
                        <Link className="session" to={`/session-detail/${item.sessionId}`}><span>{item.title}</span></Link>
                        <span className="time-session">{item.startTime} - {item.endTime} {item.endDate}</span>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2 mb-2">
                        <span>{item.status}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="row history-detail">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-12">
                      <span style={{ color: '#FFFFFF80' }}>{I18n.t('no_transaction_history')}</span>
                    </div>
                  </div>
                )
              }
            </div>
          </div>

          <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12 package-row">
            <p className="title"> {I18n.t('purchase_history')} </p>

            <div className="info">
              <div className="row history">
                <div className="col-lg-2 col-md-2 col-sm-2 mb-3">
                  <span>{I18n.t('purchase_time')}</span>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 mb-3">
                  <span>{I18n.t('purchased_package')}</span>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                  <span>{I18n.t('price')}</span>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                  <span>{I18n.t('amount_paid')}</span>
                </div>
              </div>

              {
                historyTransactions && historyTransactions.length > 0 ? (
                  historyTransactions.map((item, index) => (
                    <div key={index} className="row history-detail transaction-detail">
                      <div className="col-lg-2 col-md-2 col-sm-2 mb-3">
                        <span>{item.time}</span>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 mb-3 ">
                        <span>{item.package}</span>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                        <span>{item.rawPrice} USD</span>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                        <span>
                          {item.amount} {item.currency}
                          {
                            !!item.percent && (<span> (-{item.percent} %)</span>)
                          }
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="row history-detail transaction-detail">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-12 text-center">
                      <span style={{ color: '#FFFFFF80' }}>{I18n.t('no_purchase_history')}</span>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { mvp, user } = state;
  return {
    user
  }
};

const mapDispatchToProps = (dispatch) => ({
  getHistoryUseSessions: () => dispatch(sessionActions.getHistoryUseSessions()),
  getHistoryTransactions: () => dispatch(sessionActions.getHistoryTransactions())
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPackageContent);

